import axios from 'axios';

const API_BASE_URL = 'https://mediaassociation.co.in/media_association_back_end_laravel/public/api/api/v1';

export const imagaeAPI = 'https://mediaassociation.co.in/media_association_back_end_laravel/storage/app/public'





const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const currentPath = window.location.pathname;
            // List of public routes that should NOT redirect
            const publicPaths = ['/', '/homepage', '/login'];
            if (!publicPaths.includes(currentPath)) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/homepage';
            }
            // If on a public route, just reject so the component can handle the error
        }
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);




export const sliderService = {
    getAll: () => api.get('/sliders'),
};

export const memberService = {
    // getAll: () => api.get('/members'),
    getAll: (params = {}) => api.get('/members', { params }),
    getById: (id) => api.get(`/members/${id}`),
    create: (data) => api.post('/memberegister', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.put(`/members/${id}`, data),
    delete: (id) => api.delete(`/members/${id}`),
};

export const pageService = {
    getAbout: () => api.get('/about'),
    getMembership: () => api.get('/membership'),
    getPrivacy: () => api.get('/privacy'),
    getTerms: () => api.get('/terms'),
    getRefund: () => api.get('/refund'),
};

export const contactService = {
    send: (data) => api.post('/contact', data),
};















export default api;